/*
 * @Author: Hyman Choi
 * @Date: 2020-08-27 15:18:07
 * @LastEditTime: 2021-01-05 17:30:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.LiveWeb\src\api\userDistribution.js
 */
import request from '@/utils/request'
import config from '@/utils/config';

/**
 * 获取用户分布情况信息
 *
 * @param {*} params
 */
export function getProvinceUserData(params = {}) {
  return request({
    url: config.API_LIVE + '/live_server/manage/live/provinceUserData',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/userDistribution.js